import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';

import { ActionWith } from 'common/interfaces/action-with';
import { AccountActions } from '../../../units/account/actions/creators';
import { ValidationField } from '../../../units/account/actions/payloads';
import { PaymentMethodActions } from '../actions/creators';
import { PaymentMethodActionTypes } from '../actions/types';
import { PaymentMethodsApi } from '../api/payment-methods';
import { BillingCountryModel } from '../interfaces/billing-country-model';
import { CreateBillingCardForm } from '../interfaces/create-billing-card-form';
import { PaymentSourcesModel } from '../interfaces/payment-sources-model';


function* createCard(action: ActionWith<CreateBillingCardForm>): SagaIterator {
  try {
    const payment: PaymentSourcesModel = yield call(PaymentMethodsApi.createPaymentMethod, action.payload);
    yield put(PaymentMethodActions.createCardSucceeded(payment));
    yield put(AccountActions.setSubscribeError(ValidationField.RenewSubscription, ''));
  } catch (error) {
    yield put(PaymentMethodActions.createCardFailed());
    console.error('paymentMethod: create card failed', error, action.payload);
  }
}

function* getCardsAndBillingCountries(): SagaIterator {
  try {
    const payment: PaymentSourcesModel = yield call(PaymentMethodsApi.getPaymentMethods);
    const billingCountries: BillingCountryModel[] = yield call(PaymentMethodsApi.getAvailableBillingCountries);
    yield put(PaymentMethodActions.getPaymentMethodsSucceeded(payment));
    yield put(PaymentMethodActions.setAvailableBillingCountries(billingCountries));
  } catch (error) {
    yield put(PaymentMethodActions.getPaymentMethodsFailed());
    console.error('paymentMethod: get cards failed', error);
  }
}

function* removeCard(action: ActionWith<string>): SagaIterator {
  try {
    const payment: PaymentSourcesModel = yield call(PaymentMethodsApi.deletePaymentMethod, action.payload);
    yield put(PaymentMethodActions.removeCardSucceeded(payment));
  } catch (error) {
    yield put(PaymentMethodActions.removeCardFailed());
    console.error('paymentMethod: remove card failed', error);
  }
}

function* setPrimaryCard(action: ActionWith<string>): SagaIterator {
  try {
    const payment: PaymentSourcesModel = yield call(PaymentMethodsApi.setPrimaryPaymentMethod, action.payload);
    yield put(PaymentMethodActions.setPrimaryCardSucceeded(payment));
  } catch (error) {
    yield put(PaymentMethodActions.setPrimaryCardFailed());
    console.error('paymentMethod: remove card failed', error);
  }
}

function* setBackupCard(action: ActionWith<string>): SagaIterator {
  try {
    const payment: PaymentSourcesModel = yield call(PaymentMethodsApi.setBackupPaymentMethod, action.payload);
    yield put(PaymentMethodActions.setBackupCardSucceeded(payment));
  } catch (error) {
    yield put(PaymentMethodActions.setBackupCardFailed());
    console.error('paymentMethod: remove card failed', error);
  }
}


export function* paymentSagas(): SagaIterator {
  yield takeLatest(PaymentMethodActionTypes.CREATE_CARD, createCard);
  yield takeLatest(PaymentMethodActionTypes.REMOVE_CARD, removeCard);
  yield takeLatest(PaymentMethodActionTypes.GET_PAYMENT_METHODS, getCardsAndBillingCountries);
  yield takeLatest(PaymentMethodActionTypes.SET_PRIMARY_CARD, setPrimaryCard);
  yield takeLatest(PaymentMethodActionTypes.SET_BACKUP_CARD, setBackupCard);
}
